import { DEALER_DEFAULT_VALUE } from '@/app/components/shared/dealer/utils/dealer-constant';

export const createDealerNameFormat = (name?: string) => {
  const dealerName = name || DEALER_DEFAULT_VALUE.NAME;
  const splitDealerNameArrays = dealerName.split(' ').map((item) => {
    if (item.includes('((')) {
      item = item.replace('((', '<span>(');
    } else {
      item = item.replace('(', '<span>(');
    }

    if (item.includes('))')) {
      item = item.replace('))', '))</span>');
    } else {
      item = item.replace(')', ')</span>');
    }
    return item;
  });

  return splitDealerNameArrays.join(' ');
};
